import type { PrimaryGroup } from '../types/primary-groups';
import type { OutTypes } from './schedules';

export default function (
  primaryGroups:  PrimaryGroup[] | undefined,
  importErrors:   string[],
  importWarnings: string[],
): OutTypes.group[] {
  return primaryGroups?.map(x => { return {
    ids:         x.id.toString(),
    displayName: x.name,
    species:     'class',
  };}) ?? [];
}
